<template>
  <transition name="notice-fade">
    <div v-if="visible" class="login-notice-mask" role="dialog" aria-modal="true">
      <section class="login-notice-window">
        <div class="notice-accent"></div>
        <header class="notice-header">
          <div class="notice-mark">
            <span>ASM</span>
          </div>
          <div>
            <small>ASM PACIFIC WEALTH</small>
            <strong>重要公告</strong>
          </div>
          <button type="button" aria-label="关闭公告" @click="closeNotice">
            <van-icon name="cross" />
          </button>
        </header>

        <main class="notice-content">
          <div class="notice-title-row">
            <span></span>
            <p>NOTICE</p>
          </div>
          <h2 :style="{ color: notice.titleColor }">{{ notice.title }}</h2>
          <div class="notice-text" v-html="notice.content"></div>
        </main>

        <footer class="notice-footer">
          <p><van-icon name="shield-o" /> 请注意保护账户与资金安全</p>
          <button type="button" @click="closeNotice">
            {{ notice.button || "我已了解" }}
          </button>
        </footer>
      </section>
    </div>
  </transition>
</template>

<script>
import request from "@utils/request";
import { mapGetters } from "vuex";

export default {
  name: "LoginNoticeModal",
  data() {
    return {
      visible: false,
      storageKey: "",
      notice: {
        title: "",
        content: "",
        button: "我已了解",
        titleColor: "#172740",
        version: 0
      }
    };
  },
  computed: {
    ...mapGetters(["isLogin", "token"])
  },
  watch: {
    isLogin: {
      immediate: true,
      handler(value) {
        if (value) {
          this.loadNotice();
        } else {
          this.visible = false;
          this.restoreScroll();
        }
      }
    }
  },
  beforeDestroy() {
    this.restoreScroll();
  },
  methods: {
    loadNotice() {
      request
        .get("/api/login-notice", {}, { login: false })
        .then(res => {
          const data = (res && res.data && res.data.data) || {};
          if (!data.enabled || !String(data.content || "").trim()) {
            return;
          }
          const tokenSignature = String(this.token || "").slice(-18);
          this.storageKey =
            "asm_login_notice_" +
            String(data.version || "default") +
            "_" +
            tokenSignature;
          if (window.sessionStorage.getItem(this.storageKey)) {
            return;
          }
          this.notice = {
            title: data.title || "平台重要公告",
            content: String(data.content || "").trim(),
            button: data.button || "我已了解",
            titleColor: data.title_color || "#172740",
            version: data.version || 0
          };
          this.visible = true;
          document.body.style.overflow = "hidden";
        })
        .catch(() => {});
    },
    closeNotice() {
      if (this.storageKey) {
        window.sessionStorage.setItem(this.storageKey, "1");
      }
      this.visible = false;
      this.restoreScroll();
    },
    restoreScroll() {
      if (typeof document !== "undefined") {
        document.body.style.overflow = "";
      }
    }
  }
};
</script>

<style scoped>
.login-notice-mask {
  position: fixed;
  z-index: 9999;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    linear-gradient(rgba(3,15,34,.79),rgba(4,24,50,.86)),
    url("../assets/images/asm-premium/global-headquarters.webp") center / cover no-repeat;
  backdrop-filter: blur(5px);
}

.login-notice-window {
  position: relative;
  width: 100%;
  max-width: 410px;
  max-height: calc(100vh - 48px);
  overflow: auto;
  color: #1b2a41;
  background:
    linear-gradient(180deg,rgba(255,255,255,.985),#fff 38%),
    url("../assets/images/asm-premium/chiplet-wafer.webp") center top / 100% auto no-repeat;
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 20px;
  box-shadow: 0 28px 80px rgba(2, 18, 44, 0.35);
}

.notice-accent {
  height: 7px;
  background: linear-gradient(90deg, #0c3979, #1870bb 62%, #5fa8dc);
}

.notice-header {
  position: relative;
  isolation: isolate;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 19px 20px 16px;
  background:
    linear-gradient(90deg,rgba(247,251,255,.96),rgba(232,245,255,.78)),
    url("../assets/images/asm-premium/advanced-packaging-fab.webp") right center / 58% auto no-repeat;
  border-bottom: 1px solid #e5edf6;
}

.notice-header::before {
  position: absolute;
  z-index: -1;
  inset: 0;
  content: "";
  pointer-events: none;
  opacity: 0.58;
  background:
    radial-gradient(circle, rgba(47, 143, 205, 0.66) 0 1px, transparent 1.7px) 8px 7px / 22px 22px,
    linear-gradient(rgba(58, 145, 202, 0.12) 1px, transparent 1px) 0 0 / 22px 22px,
    linear-gradient(90deg, rgba(58, 145, 202, 0.12) 1px, transparent 1px) 0 0 / 22px 22px;
  -webkit-mask-image: linear-gradient(90deg, transparent 25%, rgba(0, 0, 0, 0.25) 48%, #000 100%);
  mask-image: linear-gradient(90deg, transparent 25%, rgba(0, 0, 0, 0.25) 48%, #000 100%);
}

.notice-header::after {
  position: absolute;
  z-index: -1;
  right: 44px;
  bottom: 8px;
  width: 118px;
  height: 45px;
  content: "";
  pointer-events: none;
  opacity: 0.6;
  background:
    radial-gradient(circle at 0 20%, #399bd4 0 2px, transparent 2.5px),
    radial-gradient(circle at 46% 20%, #399bd4 0 2px, transparent 2.5px),
    radial-gradient(circle at 46% 80%, #399bd4 0 2px, transparent 2.5px),
    radial-gradient(circle at 100% 80%, #399bd4 0 2px, transparent 2.5px),
    linear-gradient(90deg, #58addb, #58addb) 0 20% / 46% 1px no-repeat,
    linear-gradient(#58addb, #58addb) 46% 20% / 1px 60% no-repeat,
    linear-gradient(90deg, #58addb, #58addb) 46% 80% / 54% 1px no-repeat;
  filter: drop-shadow(0 0 4px rgba(42, 153, 211, 0.45));
}

.notice-header > * {
  position: relative;
  z-index: 1;
}

.notice-mark {
  position: relative;
  display: grid;
  width: 42px;
  height: 42px;
  margin-right: 11px;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  place-items: center;
  background: linear-gradient(145deg, #082d65, #176cb2);
  border-radius: 12px;
  box-shadow: 0 7px 18px rgba(15, 84, 151, 0.22);
}

.notice-mark::before {
  position: absolute;
  inset: 5px;
  content: "";
  pointer-events: none;
  border: 1px solid rgba(151, 220, 255, 0.35);
  border-radius: 8px;
}

.notice-header small,
.notice-header strong {
  display: block;
}

.notice-header small {
  color: #8a97aa;
  font-size: 8px;
  letter-spacing: 1px;
}

.notice-header strong {
  margin-top: 3px;
  color: #263750;
  font-size: 14px;
}

.notice-header > button {
  display: grid;
  width: 32px;
  height: 32px;
  margin-left: auto;
  color: #7d8a9d;
  font-size: 17px;
  place-items: center;
  background: #f3f6fa;
  border: 0;
  border-radius: 50%;
}

.notice-content {
  padding: 24px 22px 20px;
}

.notice-title-row {
  display: flex;
  align-items: center;
  gap: 7px;
}

.notice-title-row span {
  width: 20px;
  height: 3px;
  background: #2375bc;
  border-radius: 2px;
}

.notice-title-row p {
  margin: 0;
  color: #2474b9;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 1.5px;
}

.notice-content h2 {
  margin: 12px 0 15px;
  color: #172740;
  font-size: 22px;
  line-height: 1.4;
}

.notice-text {
  max-height: 310px;
  overflow-y: auto;
  color: #5e6e83;
  font-size: 13px;
  line-height: 1.9;
  overflow-wrap: anywhere;
}
.notice-text /deep/ img {
  max-width: 100% !important;
  height: auto !important;
}
.notice-text /deep/ video,
.notice-text /deep/ iframe {
  display: block;
  max-width: 100% !important;
}
.notice-text /deep/ table {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}

.notice-footer {
  padding: 16px 22px 22px;
  background: #f7f9fc;
  border-top: 1px solid #edf1f6;
}

.notice-footer p {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0 0 13px;
  color: #7a8799;
  font-size: 10px;
}

.notice-footer button {
  width: 100%;
  height: 43px;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  background: linear-gradient(90deg, #10519b, #2177bf);
  border: 0;
  border-radius: 11px;
  box-shadow: 0 9px 20px rgba(20, 93, 162, 0.2);
}

.notice-fade-enter-active,
.notice-fade-leave-active {
  transition: opacity 0.22s ease;
}

.notice-fade-enter-active .login-notice-window,
.notice-fade-leave-active .login-notice-window {
  transition: transform 0.22s ease;
}

.notice-fade-enter,
.notice-fade-leave-to {
  opacity: 0;
}

.notice-fade-enter .login-notice-window,
.notice-fade-leave-to .login-notice-window {
  transform: translateY(12px) scale(0.97);
}
</style>
